/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Wise_Panda_TiltInputs */

const en_full_wise_panda_tilt = /** @type {(inputs: Full_Wise_Panda_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Participation Groups`)
};

const de_full_wise_panda_tilt = /** @type {(inputs: Full_Wise_Panda_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmegruppen importieren`)
};

/**
* | output |
* | --- |
* | "Import Participation Groups" |
*
* @param {Full_Wise_Panda_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_wise_panda_tilt = /** @type {((inputs?: Full_Wise_Panda_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Wise_Panda_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_wise_panda_tilt(inputs)
	return de_full_wise_panda_tilt(inputs)
});